const isDevelopment = () => {
    return !!process.env.REACT_APP_IS_DEVELOPMENT;
};

const apiUrl = () => {
    if (isDevelopment()) {
        return "https://dev-crj.jeekim-server.com/";
    }

    return "https://crj.jeekim-server.com/";
};

export const EnvironmentConstants = {
    isDevelopment: isDevelopment(),
    apiUrl: apiUrl(),
};
